import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import "../css/main.scss";

function Main() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="main">
      <Header />

      <main className="main-content">
        <div className="main-row full-width">
          <Link to="/shop" onClick={toTop} className="image-link">
            <img src="/img/shiskerstone/product-12.svg#view-1" alt="Pre-Order: FW '26 Collection" />
            <p className="image-caption">Pre-Order: FW '26 Collection</p>
          </Link>
        </div>

        <div className="main-row half-width">
          <Link to="/shop" onClick={toTop} className="image-link">
            <img src="/img/shiskerstone/product-05.svg#view-1" alt="Rings" />
            <p className="image-caption">Rings</p>
          </Link>
          <Link to="/shop" onClick={toTop} className="image-link">
            <img src="/img/shiskerstone/product-08.svg#view-1" alt="Earrings" />
            <p className="image-caption">Earrings</p>
          </Link>
        </div>

        <div className="main-row full-width">
          <Link to="/shop" onClick={toTop} className="image-link">
            <img src="/img/shiskerstone/product-09.svg#view-1" alt="Objects" />
            <p className="image-caption">Objects</p>
          </Link>
        </div>

        <div className="main-row half-width">
          <Link to="/shop" onClick={toTop} className="image-link">
            <img src="/img/shiskerstone/product-07.svg#view-1" alt="Necklaces" />
            <p className="image-caption">Necklaces</p>
          </Link>
          <Link to="/shop" onClick={toTop} className="image-link">
            <img src="/img/shiskerstone/product-13.svg#view-2" alt="FW '26 Campaign" />
            <p className="image-caption">FW '26 Campaign</p>
          </Link>
        </div>

        <div className="main-row half-width padded-images">
          <Link to="/shop" onClick={toTop} className="image-link">
            <img src="/img/shiskerstone/product-01.svg#view-1" alt="shiskerstone Edit" />
            <p className="image-caption">shiskerstone Edit</p>
          </Link>
          <Link to="/shop" onClick={toTop} className="image-link">
            <img src="/img/shiskerstone/product-19.svg#view-1" alt="Keepsake Objects" />
            <p className="image-caption">Keepsake Objects</p>
          </Link>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Main;
